import { render, staticRenderFns } from "./add_user_confirm.vue?vue&type=template&id=ceb2101a"
import script from "./add_user_confirm.vue?vue&type=script&lang=js"
export * from "./add_user_confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports